// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q8jGpSNATRHHYaKatA_n {
  /* text-align: right;
  margin: 10px 10px 0 80px;
  top: -35px;
  left: -15px;  */
  /* padding-left: 20px; */
  position: relative;
}

.SA8URi2WsFNmat8vUuw6 {
  display: flex;
  justify-content: flex-end;
  grid-gap: 50px;
  gap: 20px;
  position: absolute;
  padding-right: 25px;
  top: -41px;
  right: 0px;
  text-align: center;
}

.dWU15_se1kGatzPCIMuc {
  /* padding-top: 20px; */
  height: calc(100vh - 150px);
  overflow: auto;
  margin: 0px 20px 0px 30px;
}

.SA8URi2WsFNmat8vUuw6 input {
  padding: 10px;
  height: 35px;
}

.SA8URi2WsFNmat8vUuw6 button {
  height: 35px;
  width: 70px;
  margin-left: -70px;
  border: none;
  background-color: #1976d2;
  color: white;
  cursor: pointer;
}

.VDLQEKWyarYJKUPJqb8i {
  height: calc(100vh - 190px);
  overflow-y: auto;
  overflow-wrap: break-word;
}

.VDLQEKWyarYJKUPJqb8i::-webkit-scrollbar {
  width: 3px;
}

.VDLQEKWyarYJKUPJqb8i::-webkit-scrollbar-thumb {
  background-color: gray;
}

.rIMpvg3aI5yl6ovlScJD {
  text-align: left;
  margin-bottom: 10px;
}

.anfDydMjv4iotVsWhAoo {
  font-weight: 500;
}

@media only screen and (max-width: 778px) {
  .Q8jGpSNATRHHYaKatA_n {
    padding: 0px;
  }
  .SA8URi2WsFNmat8vUuw6 {
    display: flex;
    justify-content: flex-end;
    grid-gap: 50px;
    gap: 20px;
    position: relative;
    padding-right: 25px;
    top: 16px;
    right: 0px;
    text-align: center;
    padding-left: 10px;
    margin-bottom: 25px;
  }
  .dWU15_se1kGatzPCIMuc {
    margin: 0px;
    padding-bottom: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./components/Logs/logs.module.css"],"names":[],"mappings":"AAAA;EACE;;;iBAAA;EAIA,wBAAA;EACA,kBAAA;AACF;;AACA;EACE,aAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;AAEF;;AAAA;EACE,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,yBAAA;AAGF;;AADA;EACE,aAAA;EACA,YAAA;AAIF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAKF;;AAHA;EACE,2BAAA;EACA,gBAAA;EACA,yBAAA;AAMF;;AAHA;EACE,UAAA;AAMF;;AAHA;EACE,sBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,mBAAA;AAMF;;AAHA;EACE,gBAAA;AAMF;;AAJA;EACE;IACE,YAAA;EAOF;EALA;IACE,aAAA;IACA,yBAAA;IACA,cAAA;IACA,SAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;IACA,mBAAA;EAOF;EALA;IACE,WAAA;IACA,oBAAA;EAOF;AACF","sourcesContent":[".logs {\n  /* text-align: right;\n  margin: 10px 10px 0 80px;\n  top: -35px;\n  left: -15px;  */\n  /* padding-left: 20px; */\n  position: relative;\n}\n.log_bar {\n  display: flex;\n  justify-content: flex-end;\n  grid-gap: 50px;\n  gap: 20px;\n  position: absolute;\n  padding-right: 25px;\n  top: -41px;\n  right: 0px;\n  text-align: center;\n}\n.logsbackground {\n  /* padding-top: 20px; */\n  height: calc(100vh - 150px);\n  overflow: auto;\n  margin: 0px 20px 0px 30px;\n}\n.log_bar input {\n  padding: 10px;\n  height: 35px;\n}\n.log_bar button {\n  height: 35px;\n  width: 70px;\n  margin-left: -70px;\n  border: none;\n  background-color: #1976d2;\n  color: white;\n  cursor: pointer;\n}\n.logsItems {\n  height: calc(100vh - 190px);\n  overflow-y: auto;\n  overflow-wrap: break-word;\n}\n\n.logsItems::-webkit-scrollbar {\n  width: 3px;\n}\n\n.logsItems::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.log {\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.paralog {\n  font-weight: 500;\n}\n@media only screen and (max-width: 778px) {\n  .logs {\n    padding: 0px;\n  }\n  .log_bar {\n    display: flex;\n    justify-content: flex-end;\n    grid-gap: 50px;\n    gap: 20px;\n    position: relative;\n    padding-right: 25px;\n    top: 16px;\n    right: 0px;\n    text-align: center;\n    padding-left: 10px;\n    margin-bottom: 25px;\n  }\n  .logsbackground {\n    margin: 0px;\n    padding-bottom: 90px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logs": `Q8jGpSNATRHHYaKatA_n`,
	"log_bar": `SA8URi2WsFNmat8vUuw6`,
	"logsbackground": `dWU15_se1kGatzPCIMuc`,
	"logsItems": `VDLQEKWyarYJKUPJqb8i`,
	"log": `rIMpvg3aI5yl6ovlScJD`,
	"paralog": `anfDydMjv4iotVsWhAoo`
};
export default ___CSS_LOADER_EXPORT___;
